import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"white-space":"normal","word-break":"break-word","line-height":"1.4"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, {
      color: "#1F7087",
      dark: "",
      to: `/memoru/album/${_ctx.album.albumId}`,
      height: "300px",
      class: "pa-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_img, {
          src: _ctx.album.thumbnailImage.url || '',
          sizes: "200px",
          height: "180px"
        }, null, 8, ["src"]),
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "x-small",
                      start: "",
                      color: _ctx.available ? `success` : `error`
                    }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("mdi-circle", -1)
                      ]))]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", _hoisted_1, _toDisplayString(_ctx.album.title), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.album.comment || ""), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}